import { useCallback, useRef } from "react";
import useAudioTrackMonitor from "./useAudioTrackMonitor";
import styles from "./AudioInputLevelHorizontal.module.scss";

const AudioInputLevelHorizontal = ({
  mediaStreamTrack,
}: {
  mediaStreamTrack?: MediaStreamTrack;
}) => {
  const levelRef = useRef<HTMLDivElement>(null);

  const onLevelChanged = useCallback((level: number) => {
    if (!levelRef.current) {
      return;
    }
    levelRef.current.style.width = `${level * 24}px`;
  }, []);

  useAudioTrackMonitor(mediaStreamTrack, onLevelChanged);

  return (
    <div className={styles.container}>
      <div className={styles.level} ref={levelRef} />
      <div className={styles.track} />
    </div>
  );
};

export default AudioInputLevelHorizontal;
